import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import MyButton from "./myButton"; // Assuming this is a styled button component

const LogoutConfirmationBox = ({ openExitDialogue, onExitDialogue, onConfirmLogout }) => {
  return (
    <Dialog
      open={openExitDialogue}
      onClose={() => onExitDialogue(false)}
      aria-labelledby="logout-dialog-title"
      aria-describedby="logout-dialog-description"
      PaperProps={{
        style: {
          backgroundColor: "#1a1c24",
          color: "white",
          padding: "20px",
          borderRadius: "12px",
          position: "relative",
        },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={() => onExitDialogue(false)}
        sx={{ position: "absolute", top: 10, right: 10, color: "white" }}
      >
        <i className="fa fa-times" style={{ fontSize: "24px" }}></i>
      </IconButton>

      {/* Icon */}
      <div
        style={{
          textAlign: "center",
          marginTop: "20px",
          marginBottom: "10px",
        }}
      >
        <div
          style={{
            background: "#2a2c35",
            borderRadius: "20px",
            width: "64px",
            height: "64px",
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <i className="fa fa-sign-out" style={{ fontSize: "32px", color: "#e20074" }}></i>
        </div>
      </div>

      {/* Title */}
      <DialogTitle id="logout-dialog-title" sx={{ textAlign: "center" }}>
        <Typography variant="h6" fontWeight="bold">
          Are you sure you want to log out?
        </Typography>
      </DialogTitle>

      {/* Description */}
      <DialogContent>
        <DialogContentText
          id="logout-dialog-description"
          sx={{ textAlign: "center", color: "#a0a0a0" }}
        >
          You will be asked to log in again to watch your favourites.
        </DialogContentText>
      </DialogContent>

      {/* Action Buttons */}
      <DialogActions sx={{ justifyContent: "center", padding: "16px" }}>
        <MyButton
          title="Cancel"
          openExitDialogue={() => onExitDialogue(false)}
          style={{ backgroundColor: "#2c2f39", color: "#fff" }}
        />
        <MyButton
          title="Log Out"
          openExitDialogue={onConfirmLogout}
          style={{
            background: "linear-gradient(to right, #0099ff, #e20074)",
            color: "white",
          }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default LogoutConfirmationBox;
